import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ConnectRefreshActiveStatusBanner } from '../ConnectAnnouncementBanner/ConnectRefreshActiveStatusBanner';
import { ConnectMatchesNotificationBanner } from '../ConnectAnnouncementBanner/ConnectMatchesNotificationBanner';
import auth from '../../../../utils/auth';
import { useConnectContext } from '../../features/Context/ConnectContextProvider';
import { userTypeToId } from 'utils/typedEnums';
import { shouldDisplayRefreshActiveJobSeekingStatusBanner } from './utils';
import { candidatePortalRedirectUrls, CONNECT_URL } from 'utils/constants';
import { connectRedirectUrls } from 'utils/constants/connect';

export function BannerManager(): React.ReactElement | null {
  const { candidateMatches } = useConnectContext();
  const isConnectPage = useRouteMatch({ path: CONNECT_URL, exact: false });
  const isConnectPreferencesPage = useRouteMatch({
    path: connectRedirectUrls.PREFERENCES,
    exact: true,
  });
  const isCandidatePortalPage = useRouteMatch({
    path: candidatePortalRedirectUrls.CANDIDATE_PORTAL,
    exact: false,
  });

  const authenticatedUser = auth.getUser();
  const isAuthenticated = auth.loggedIn();

  const showConnectRefreshActiveStatusBanner = useMemo(
    () =>
      shouldDisplayRefreshActiveJobSeekingStatusBanner(
        authenticatedUser,
        !!isConnectPreferencesPage
      ),
    [authenticatedUser, isConnectPreferencesPage]
  );
  const showConnectMatchesNotificationBanner =
    !showConnectRefreshActiveStatusBanner &&
    isAuthenticated &&
    candidateMatches?.pending?.length > 0 &&
    !isCandidatePortalPage;

  // Currently we only show banners on Connect pages for authenticated users
  if (
    !isConnectPage ||
    !auth.loggedIn() ||
    authenticatedUser.profile.user_type !== userTypeToId.candidate
  ) {
    return null;
  }

  // NOTE:
  // ConnectRefreshActiveStatusBanner should NOT show up on Connect Preferences page
  // ConnectMatchesNotificationBanner should NOT show up on any Candidate Portal page

  if (showConnectRefreshActiveStatusBanner) {
    return <ConnectRefreshActiveStatusBanner user={authenticatedUser} />;
  } else if (showConnectMatchesNotificationBanner) {
    return <ConnectMatchesNotificationBanner />;
  } else {
    return null;
  }
}
